import axios from 'axios'
import store from '@/store'

const BASE_URL = 'https://clubtest.intrare.app'

const getConfig = () => ({
  method: 'get',
  headers: {
    'Content-Type': 'application/json',
    'authorization': `Token ${store.getters.getToken}`
  }
})

// OUTINGS API
export const marshallOutingsApi = {
  // Obtener todas las salidas
  getOutings (params = {}) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/outings/`,
      params
    })
  },

  // Obtener salidas por fecha
  getOutingsByDate (date) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/outings/`,
      params: { date }
    })
  },

  // Obtener salida específica
  getOuting (id) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/outings/${id}/`
    })
  },

  // Crear nueva salida
  createOuting (data) {
    return axios({
      method: 'post',
      url: `${BASE_URL}/marshall/outings/`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Token ${store.getters.getToken}`
      },
      data
    })
  },

  // Actualizar salida (hoyo, ritmo, etc.)
  updateOuting (id, data) {
    return axios({
      method: 'patch',
      url: `${BASE_URL}/marshall/outings/${id}/`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Token ${store.getters.getToken}`
      },
      data
    })
  },

  // Eliminar salida
  deleteOuting (id) {
    return axios({
      method: 'delete',
      url: `${BASE_URL}/marshall/outings/${id}/`,
      headers: {
        'authorization': `Token ${store.getters.getToken}`
      }
    })
  }
}

// WARNINGS API
export const marshallWarningsApi = {
  // Obtener catálogo de amonestaciones
  getWarningCatalog () {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/warning-catalog/`
    })
  },

  // Obtener historial de amonestaciones
  getWarnings (params = {}) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/warnings/`,
      params
    })
  },

  // Obtener amonestación específica
  getWarning (id) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/warnings/${id}/`
    })
  },

  // Registrar nueva amonestación
  createWarning (data) {
    return axios({
      method: 'post',
      url: `${BASE_URL}/marshall/warnings/`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Token ${store.getters.getToken}`
      },
      data
    })
  }
}

// PLAYER FILES API
export const marshallPlayerFilesApi = {
  // Obtener expedientes de jugadores
  getPlayerFiles (params = {}) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/player-files/`,
      params
    })
  },

  // Obtener expediente específico del jugador
  getPlayerFile (playerId) {
    return axios({
      ...getConfig(),
      url: `${BASE_URL}/marshall/player-files/${playerId}/`
    })
  }
}

export default {
  marshallOutingsApi,
  marshallWarningsApi,
  marshallPlayerFilesApi
}
